/**
 * Which speaker on a call is the customer, and which side of the transcript each speaker sits on.
 *
 * "Customer" is the only reliable label: in standard mode it comes from the SpeakerNames parameter, in Call
 * Analytics mode from the participant role, and the Genesys step renames the AGENT to the agent's own name
 * (and adds a speaker per agent joining after a transfer) while the customer keeps "Customer".
 */

/** The customer's speaker code. Same rule as the server's `lambda/index.js`: the "Customer" label, else spk_1. */
export const customerSpeakerOf = (analytics) => {
  const labels = Array.isArray(analytics?.SpeakerLabels) ? analytics.SpeakerLabels : [];
  const hit = labels.find((l) => String(l?.DisplayText || '').trim() === 'Customer');
  return hit?.Speaker || 'spk_1';
};

/**
 * 'left' for the customer and anyone who is not an agent (IVR, an unknown or unlabelled speaker),
 * 'right' for agents — including an agent who joined after a transfer under their own name.
 */
export const sideOf = (speaker, { customerSpeaker, labels } = {}) => {
  if (!speaker || speaker === customerSpeaker) return 'left';
  const label = String(labels?.[speaker] ?? '').trim();
  if (!label || label === 'Customer' || /^ivr$/i.test(label) || /^unknown/i.test(label)) return 'left';
  return 'right';
};
